import { languageCodes } from '../i18n.js';
export const seasonsUrlFragment = {
    summer: {
        en: 'summer',
        fr: 'ete',
        de: 'sommer',
        it: 'estate',
    },
    winter: {
        en: 'winter',
        de: 'winter',
        fr: 'hiver',
        it: 'inverno',
    },
};
export const landUrlFragment = {
    hike: {
        en: 'hiking-in-switzerland',
        fr: 'suisse-a-pied',
        it: 'svizzera-a-piedi',
        de: 'wanderland',
    },
    cycle: {
        en: 'cycling-in-switzerland',
        fr: 'suisse-a-velo',
        de: 'veloland',
        it: 'svizzera-in-bici',
    },
    mountainbike: {
        en: 'mountainbiking-in-switzerland',
        fr: 'suisse-a-vtt',
        de: 'mountainbikeland',
        it: 'svizzera-in-mountain-bike',
    },
    skate: {
        en: 'skating-in-switzerland',
        fr: 'suisse-en-rollers',
        de: 'skatingland',
        it: 'svizzera-in-skating',
    },
    canoe: {
        en: 'canoeing-in-switzerland',
        fr: 'suisse-en-canoe',
        de: 'kanuland',
        it: 'svizzera-in-canoa',
    },
    winterhike: {
        en: 'winter-hiking',
        fr: 'randonnees-hivernales',
        de: 'winterwandern',
        it: 'escursioni-invernali',
    },
    snowshoe: {
        en: 'snowshoe-trekking',
        fr: 'randonnees-en-raquettes',
        de: 'schneeschuhwandern',
        it: 'ciaspolate',
    },
    crosscountry: {
        en: 'cross-country-skiing',
        fr: 'ski-de-fond',
        de: 'langlaufen',
        it: 'sci-di-fondo',
    },
    sledge: {
        en: 'sledging',
        fr: 'luge',
        de: 'schlitteln',
        it: 'slittino',
    },
};
export const overlayDirectUrlFragment = {
    place: {
        en: 'place',
        de: 'ort',
        fr: 'lieux',
        it: 'localita',
    },
    sightseeing: {
        en: 'place-of-interest',
        de: 'sehenswuerdigkeit',
        fr: 'curiosite',
        it: 'curiosita',
    },
    accommodation: {
        en: 'accommodation',
        de: 'uebernachten',
        fr: 'hebergements',
        it: 'alloggio',
    },
    cycleservice: {
        en: 'cycle-service',
        de: 'veloservice',
        fr: 'service-velo',
        it: 'assistenza-bici',
    },
    velorental: {
        en: 'bicycle-and-e-bike-rental',
        de: 'miete-velo-und-e-bike',
        fr: 'location-de-velos-et-e-bikes',
        it: 'noleggio-bici-ed-e-bike',
    },
    detour: {
        en: 'closures-and-detours',
        de: 'sperrungen-und-umleitungen',
        fr: 'fermetures-et-deviations',
        it: 'chiusure-e-deviazioni',
    },
    swisspark: {
        en: 'swiss-parks',
        de: 'schweizer-paerke',
        fr: 'parcs-suisses',
        it: 'parchi-svizzeri',
    },
    station: {
        en: 'public-transport',
        de: 'oeffentlicher-verkehr',
        fr: 'transports-publics',
        it: 'trasporti-pubblici',
    },
    slowup: {
        en: 'slowup',
        de: 'slowup',
        fr: 'slowup',
        it: 'slowup',
    },
    travelreport: {
        en: 'travel-report',
        de: 'reisebericht',
        fr: 'carnet-de-voyage',
        it: 'relazione-di-viaggio',
    },
};
export const oldOverlayDirectUrlFragment = {
    travelreport: {
        en: 'travel-reports',
        de: 'reiseberichte',
        fr: 'carnets-de-route',
        it: 'relazioni-di-viaggio',
    },
    place: {
        en: 'places',
        de: 'orte',
        fr: 'lieux',
        it: 'localita',
    },
    sightseeing: {
        en: 'places-of-interest',
        de: 'sehenswuerdigkeiten',
        fr: 'curiosites',
        it: 'curiosita',
    },
};
export const routeCategoriesUrlFragment = {
    national: {
        en: 'national-routes',
        fr: 'itineraires-nationaux',
        it: 'percorsi-nazionali',
        de: 'nationale-routen',
    },
    regional: {
        en: 'regional-routes',
        fr: 'itineraires-regionaux',
        it: 'percorsi-regionali',
        de: 'regionale-routen',
    },
    local: {
        en: 'local-routes',
        fr: 'itineraires-locaux',
        it: 'percorsi-locali',
        de: 'lokale-routen',
    },
    handicap: {
        en: 'obstacle-free-routes',
        fr: 'chemins-sans-obstacles',
        it: 'sentieri-senza-barriere',
        de: 'hindernisfreie-wege',
    },
    trails: {
        en: 'trails',
        fr: 'trails',
        it: 'trails',
        de: 'trails',
    },
};
export function parseIntWithPrefix(str, prefix) {
    if (str && str.startsWith(prefix)) {
        str = str.substring(prefix.length);
        if (str[0] === '-') {
            str = str.substring(1);
        }
        return parseInt(str, 10);
    }
    return 0;
}
export function getRouteAndSegmentNumbers(str) {
    if (!str) {
        return undefined;
    }
    for (const lang of languageCodes) {
        const prefix = segmentUrlFragment[lang];
        if (str.startsWith(prefix)) {
            str = str.substring(prefix.length);
            const numbers = str.split('.').map((number) => parseInt(number, 10));
            if (numbers.length === 2 &&
                numbers.every((number) => !Number.isNaN(number))) {
                return numbers;
            }
            else {
                return undefined;
            }
        }
    }
    return undefined;
}
export const mapUrlFragment = {
    en: 'map',
    de: 'map',
    fr: 'map',
    it: 'map',
};
export const routeUrlFragment = {
    en: 'route',
    de: 'route',
    fr: 'itineraire',
    it: 'percorso',
};
export const legendUrlFragment = {
    en: 'legend',
    it: 'didascalie',
    fr: 'legendes',
    de: 'legende',
};
export const slowupLegendUrlFragment = {
    en: 'slowup-legend',
    it: 'slowup-didascalie',
    fr: 'slowup-legendes',
    de: 'slowup-legende',
};
export const publishingCreditsUrlFragment = {
    en: 'publishing-credits',
    de: 'impressum',
    fr: 'impressum',
    it: 'sigla-editoriale',
};
export const legacyMediaUrlFragment = {
    en: 'media',
    de: 'medien',
    fr: 'medias',
    it: 'media',
};
export const mediaUrlFragment = {
    en: 'for-media',
    de: 'fuer-medien',
    fr: 'pour-les-medias',
    it: 'per-i-media',
};
export const legacyChmServiceUrlFragment = {
    en: 'switzerlandmobility-services',
    de: 'schweizmobil-services',
    fr: 'services-de-suissemobile',
    it: 'servizi-di-svizzeramobile',
};
export const chmServiceUrlFragment = {
    en: 'switzerlandmobility-partners',
    de: 'schweizmobil-partner',
    fr: 'suissemobile-partenaires',
    it: 'svizzeramobile-partner',
};
export const chmServiceRedirect = {
    en: 'https://schweizmobil.info/',
    de: 'https://schweizmobil.info/',
    fr: 'https://schweizmobil.info/fr',
    it: 'https://schweizmobil.info/it',
};
export const legacyMobileUrlFragment = {
    en: 'switzerlandmobility-app-e',
    de: 'app-schweizmobil-d',
    fr: 'application-de-suissemobile-f',
    it: 'applicazione-di-svizzeramobile-i',
};
export const mobileUrlFragment = {
    en: 'switzerlandmobility-app',
    de: 'app-schweizmobil',
    fr: 'appli-suissemobile',
    it: 'app-svizzeramobile',
};
export const legacyDisclaimerUrlFragment = {
    en: 'disclaimer_en',
    it: 'disclaimer_it',
    fr: 'disclaimer_fr',
    de: 'disclaimer_de',
};
export const detoursUrlFragment = {
    en: 'closures-detours',
    it: 'chiusure-deviazioni',
    fr: 'fermetures-deviations',
    de: 'sperrungen-umleitungen',
};
export const feedbackUrlFragment = 'feedback';
export const legacyFeedbackUrlFragment = {
    en: 'contact',
    de: 'kontakt',
    fr: 'contact',
    it: 'contatto',
};
export const copyrightUrlFragment = 'copyright';
export const legacyCopyrightUrlFragment = {
    en: 'copyright-privacy-policy',
    de: 'copyright-datenschutzerklaerung',
    fr: 'copyright-protection-des-donnees',
    it: 'copyright-e-dichiarazione-sulla-protezione-dei-dati',
};
export const copyrightPhotoUrlFragment = {
    en: 'copyright-pictures',
    de: 'copyright-fotos',
    fr: 'copyright-photos',
    it: 'copyright-immagini',
};
export const schmPlusInstructionsUrlFragment = {
    en: 'instructions#website',
    de: 'anleitung#website',
    fr: 'mode-demploi#site-internet',
    it: 'istruzioni#sito-web',
};
export const schmPlusAccountUrlFragment = {
    en: 'my_account',
    de: 'konto',
    fr: 'compte',
    it: 'account',
};
export const schmPlusManageTourListUrlFragment = {
    en: 'manage-my-tour-list-website',
    de: 'meine-tourenliste-verwalten-website',
    fr: 'gerer-ma-liste-de-parcours-site-web',
    it: 'gestire-la-mia-lista-degli-itinerari-sito-web',
};
export function getIntForAnyPartFragment(urlPart, source) {
    for (const lang of languageCodes) {
        const prefix = source[lang];
        const nb = parseIntWithPrefix(urlPart, prefix);
        if (nb) {
            return nb;
        }
    }
    return Number.NaN;
}
export const segmentUrlFragment = {
    en: 'stage',
    de: 'etappe',
    fr: 'etape',
    it: 'tappa',
};
export function getAllParts1(source) {
    const found = new Set();
    for (const lang of languageCodes) {
        found.add(source[lang]);
    }
    return Array.from(found.values());
}
export function getAllParts2(source) {
    const found = new Set();
    for (const code in source) {
        for (const lang of languageCodes) {
            found.add(source[code][lang]);
        }
    }
    return Array.from(found.values());
}
export function getCodeForAnyLang(urlPart, source) {
    for (const code in source) {
        for (const lang of languageCodes) {
            if (source[code][lang] === urlPart) {
                return code;
            }
        }
    }
    return undefined;
}
export function getCodeForLang(lang, urlPart, source) {
    for (const code in source) {
        if (source[code][lang] === urlPart) {
            return code;
        }
    }
    return undefined;
}
export function getCurrentDefaultSeasonCode() {
    const summerStart = new Date('1970-03-15');
    const summerEnd = new Date('1970-11-21');
    const now = new Date();
    now.setFullYear(1970);
    const nowMillis = now.getTime();
    if (nowMillis >= summerStart.getTime() && nowMillis <= summerEnd.getTime()) {
        return 'summer';
    }
    else {
        return 'winter';
    }
}
export function createGradeFitnessStaticPageUrl(gradeOrFitness, land, lang) {
    const landShorters = {
        hike: 'wl',
        cycle: 'vl',
        mountainbike: 'ml',
        skate: 'sl',
        winterhike: 'ww',
        canoe: 'kl',
        snowshoe: 'ss',
        crosscountry: 'll',
        sledge: 'sc',
    };
    const gradeFitnessPart = {
        grade: {
            en: 'grade',
            it: 'tecnica',
            fr: 'techniquement',
            de: 'technik',
        },
        fitness: {
            en: 'fitness-level',
            it: 'forma-fisica',
            fr: 'physiquement',
            de: 'kondition',
        },
    };
    return `${gradeFitnessPart[gradeOrFitness][lang]}-${landShorters[land]}`;
}
export const toursUrlFragment = {
    en: 'tours',
    it: 'tours',
    fr: 'tours',
    de: 'tours',
};
export const tourUrlFragment = {
    en: 'tour',
    it: 'tour',
    fr: 'tour',
    de: 'tour',
};
export const recordedTourUrlFragment = {
    en: 'recordedtrack',
    it: 'recordedtrack',
    fr: 'recordedtrack',
    de: 'recordedtrack',
};
export function getShareLink(langCode, href, params) {
    const isTourPage = href.includes(`/${tourUrlFragment[langCode]}/`);
    const isToursPage = href.includes(`/${toursUrlFragment[langCode]}`);
    const isRecordedTrackPage = href.includes(`/${recordedTourUrlFragment[langCode]}/`);
    if (isTourPage || isToursPage || isRecordedTrackPage) {
        const mapHref = href.replace(/(tour|recordedtrack|tours)(.*)/, `${mapUrlFragment[langCode]}`);
        const url = new URL(mapUrlFragment[langCode], mapHref);
        if (params) {
            url.search = params.toString();
        }
        return url.href;
    }
    return href;
}
export function getTourIdFromHref(href, langCode) {
    return getTourOrRecordedTourIdFromHref(href, tourUrlFragment[langCode]);
}
export function getRecordedTourIdFromHref(href, langCode) {
    return getTourOrRecordedTourIdFromHref(href, recordedTourUrlFragment[langCode]);
}
function getTourOrRecordedTourIdFromHref(href, prefix) {
    const tourIdRe = new RegExp(`/${prefix}/([\\d]+)`);
    const tourId = href.match(tourIdRe);
    return tourId ? tourId[1] : undefined;
}
//# sourceMappingURL=urlParams.js.map